import { Locale as f, DEFAULT_LOCALE as p } from "../../constants/locale.js";
import { QUERY as n } from "../../constants/query.js";
import { useLanguageContext as L } from "../../contexts/language/LanguageContext.js";
import l from "./usePersistQuery.js";
import { underscoreLocale as g, hyphenLocale as y } from "../../util/i18n/helper/locale.js";
import { queryGetOne as A } from "../../util/query/index.js";
import { useRouter as E } from "next/router";
import * as o from "ramda";
import { useEffect as U } from "react";
import { useTranslation as G } from "react-i18next";
const N = () => {
  const a = E(), { query: m } = a, { setLanguage: u } = L(), e = A(m, n.LANGUAGE), { i18n: r } = G();
  l([n.LANGUAGE]), U(() => {
    const c = g(e || ""), t = o.find(o.equals(c), o.values(f)), s = t || p;
    u(s), window.locale = t;
    const i = y(s);
    r.changeLanguage(i);
  }, [r, e]);
};
export {
  N as default
};
//# sourceMappingURL=useLanguageQuery.js.map
